import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const Workshops = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Workshops</title>
        <meta
          name="description"
          content="Vi har workshops med teams för att få alla medarbetare ombord på jämställdhetståget."
        />
        <meta property="og:title" content="We Exist - Workshops" />
        <meta
          property="og:description"
          content="Vi har workshops med teams för att få alla medarbetare ombord på jämställdhetståget."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Workshops" />
      <ServicePageWrapper>
        <img src="./service-images/workshops.jpg" alt="workshop" />
        <p>
          Vems jobb är det egentligen att se till att ert team är jämställt?
          Svaret är att det ansvaret såklart inte ligger på en enskild individs
          axlar utan det är ett gemensamt arbete som alla i teamet behöver vara
          medvetna om och engagera sig i. Därför vill vi på We Exist bjuda in
          era teams till våra legendariska workshops. Detta är en
          halvdagsaktivitet som innehåller mycket lagarbete, självinsikt,
          aha-upplevelser och skratt! Workshopen är till för team mellan cirka 5
          - 25 personer men vi kan självklart hjälpa er även om ert behov ser
          annorlunda ut. Kontakta oss om du vill veta mer.
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
